import { modalClose_GTM } from './datalayers/utilDataLayers.json';

// Google Tag Manager
/*
  Pass gtmObj by reference.
  */
export const fireGTM = async (gtmObj, text, section, diffPaths) => {
  const tempGTMObj = Object.assign({}, gtmObj);

  // Routing tracking
  if (!diffPaths) {
    if (text && section) {
      tempGTMObj.text = text.toLowerCase();
      tempGTMObj.section = section
        .replace(/[`~!@#$%^&*()_|+=?;:'",.<>{}[]\\\/]/gi, '')
        .toLowerCase();
    } else if (text) {
      tempGTMObj.text = text.toLowerCase();
    } else if (section) {
      tempGTMObj.section = section
        .replace(/[`~!@#$%^&*()_|+=?;:'",.<>{}[]\\\/]/gi, '')
        .toLowerCase();
    } else {
      tempGTMObj.text = gtmObj.text.toLowerCase();
      tempGTMObj.section = gtmObj.section.toLowerCase();
    }

    if (gtmObj && gtmObj.component) {
      tempGTMObj.component = gtmObj.component.toLowerCase();
    }
  }

  window.dataLayer.push(tempGTMObj);
};

export const closeModal = async (careerOrDegree) => {
  await fireGTM(modalClose_GTM, 'close cross', careerOrDegree.titleEn);
};
